<template lang="pug">
    
    
    section.article

        .curtain.show(ref='curtain')
        
        ArticleHeader(:content='article.header' :info='parts[curPartIndex]["articles"][curArticIndex]' :curPartIndex='curPartIndex' :curArticIndex='curArticIndex')

        .sections
            Section(
                v-for='(section, sectionIndex) in article.sections'
                :theme='section.theme' 
                :content='section'
                :key='sectionIndex'
                :data-section-index='sectionIndex'
                :data-section='curPartID'
                :data-article='curArticID'
                )
        Footer(
            v-if='article.footer',
            :content='article.footer'
            theme='black'
            :curPartID='curPartID'
            :curArticID='curArticID'
            :curPartIndex='curPartIndex'
            :curArticIndex='curArticIndex'
            )
        Announce(v-if='article.announcement', :content='article.announcement')
</template>

<script>
import {parts} from '@/assets/data/menu';

export default {
    name: 'Article',
    components: {
        ArticleHeader: () => import('../components/ArticleHeader'),
        Section: () => import('../components/Section'),
        Footer: () => import('../components/Footer'),
        Announce: () => import('../components/Announce')
    },

    data() {
        return {
            article: this.$store.getters.getArticle(this.$route.params.article, this.$route.params.part),
            curPartID: this.$route.params.part,
            curArticID: this.$route.params.article,
            parts
            // curArticle: this.$route.params.article,
            // curSection: this.$route.params.section,
            // instancess: [],
            // image: this.$store.getters.getArticle(this.$route.params.article, this.$route.params.part).image,
            // title: this.$store.getters.getArticle(this.$route.params.article, this.$route.params.part).title,
        };
    },
    computed: {
        curPartIndex() {
            return parts.indexOf(parts.find(item => item.id === this.curPartID));
        },
        curArticIndex() {
            return parts[this.curPartIndex]['articles'].indexOf(this.parts[this.curPartIndex]['articles'].find(item => item.id === this.curArticID));
        }
    },

    watch: {
        $route(to, from) {
            if (to.name === 'article' && from.name === 'article')
                this.article = this.$store.getters.getArticle(this.$route.params.article, this.$route.params.part);
            this.curPartID = to.params.part;
            this.curArticID = to.params.article;
            this.$store.commit('setColor', parts[this.curPartIndex].theme);
        }
        // isActive() {
        //     if (this.isActive) this.createAnimation();
        //     else this.destroyAnimation();
        // }
    },

    beforeMount() {
        this.$store.commit('setColor', parts[this.curPartIndex].theme);
    },
    mounted() {
        this.$store.getters.getArticle(this.$route.params.article, this.$route.params.part);
        //this.$nextTick(() => this.$refs.curtain.classList.remove('show'));
        setTimeout(() => {
            this.$refs.curtain.classList.remove('show');
        }, 250);
        // if (this.$route.params.scrollPos) {
        //     setTimeout(() => {
        //         window.scrollTo(0, this.$route.params.scrollPos);
        //     }, 300);
        // }
    },

    beforeRouteUpdate(to, from, next) {
        // if (this.$route.params.scrollPos) {
        //     setTimeout(() => {
        //         window.scrollTo(0, this.$route.params.scrollPos);
        //     }, 300);
        // }

        if (to.name === from.name) {
            this.$refs.curtain.classList.add('show');

            setTimeout(() => {
                next();
                setTimeout(() => {
                    this.$refs.curtain.classList.remove('show');
                }, 300);
            }, 600);
        } else {
            next();
        }
    },
    beforeRouteLeave(to, from, next) {
        to;
        from;
        this.$refs.curtain.classList.add('show');

        setTimeout(() => {
            next();
        }, 600);
    }
};
</script>

<style lang="scss">
@import '../assets/css/vars.scss';

p:not(:last-child) {
    margin-bottom: 10px;
}

.article {
    position: relative;
    @media screen and (--viewport-tablet) {
        width: 100vw;
        overflow-x: hidden;
    }

    &__text {
        width: calc(var(--grid-column) * 13);
        padding: 0 var(--grid-column);
        margin-bottom: 40px;

        @media (--viewport-laptop) {
            width: calc(var(--grid-column-laptop) * 13);
            padding: 0 var(--grid-column-laptop);
        }

        @media (--viewport-tablet) {
            width: 100%;
        }
    }
}

.sections {
    position: relative;
    background: white;
}

.section {
    position: relative;

    &.black {
        background-color: var(--color-black);
        color: var(--color-white);
    }

    &.color {
        background-color: var(--theme);
        color: var(--color-black);
    }
}

.section-heading {
    padding: 80px 0 40px;

    @media (--viewport-tablet) {
        padding: 30px 0 15px;
    }
}

.white + .white {
    .section-heading {
        padding-top: 0;
    }
}
.textwrapper {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.section-block {
    width: var(--grid-width);
    margin: 0 auto;
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    // overflow: hidden;
    &:last-child {
        padding: 20px 0 80px;
        @media (--viewport-tablet) {
            padding: 15px 0 30px;
        }
        .image-fullsize {
            padding-bottom: 0;
            @media (--viewport-tablet) {
                padding-bottom: 0;
            }
        }
    }

    @media (--viewport-laptop) {
        width: 100%;
    }

    @media (--viewport-tablet) {
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
        padding: 15px 0 15px;
    }

    &.animation {
        width: 100%;
        padding-bottom: 0;
    }

    &.not-overflow {
        overflow: visible;
    }

    .texts {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        @media (--viewport-tablet) {
            flex-direction: column;
            align-items: flex-start;
        }

        &__wrap {
            width: calc(var(--grid-column) * 14);
            padding-left: calc(var(--grid-column) * 3);
            position: relative;
            z-index: 1;

            @media (--viewport-laptop) {
                width: calc(var(--grid-column-laptop) * 14);
                padding-left: calc(var(--grid-column-laptop) * 1);
            }

            @media (--viewport-tablet) {
                width: calc(var(--grid-column-mobile) * 13);
                padding: 0 calc(var(--grid-column-mobile) * 1);
                margin-bottom: 0px;
            }
        }

        &__side-illustration {
            width: calc(var(--grid-column) * 9);
            padding-left: calc(var(--grid-column) * 1);
            padding-right: calc(var(--grid-column) * 2);

            @media (--viewport-laptop) {
                width: calc(var(--grid-column-laptop) * 11);
                padding-left: calc(var(--grid-column-laptop) * 1);
                padding-right: calc(var(--grid-column-laptop) * 3);
            }

            @media (--viewport-tablet) {
                width: calc(var(--grid-column-mobile) * 13);
                padding: 0 calc(var(--grid-column-mobile) * 1);
            }

            @media (--viewport-mobile-lp) {
                width: fit-content;
                padding: 0;
                margin: auto;
            }
        }
    }
    &.center {
        .texts {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            @media (--viewport-tablet) {
                flex-direction: column;
                align-items: flex-start;
            }

            &__wrap {
                width: calc(var(--grid-column) * 17);
                padding-left: calc(var(--grid-column) * 6);

                @media (--viewport-laptop) {
                    width: calc(var(--grid-column-laptop) * 20);
                    padding-left: calc(var(--grid-column-laptop) * 5);
                }

                @media (--viewport-tablet) {
                    width: calc(var(--grid-column-mobile) * 12);
                    padding-left: calc(var(--grid-column-mobile) * 1);
                }
            }
        }
    }
    &.left {
        .texts {
            .quote,
            .counter {
                //padding-right: var(--grid-column);
                position: relative;
                z-index: 1;

                @media (--viewport-laptop) {
                    padding-right: 0;
                }

                @media (--viewport-tablet) {
                    padding-right: 0;
                }
            }
        }
    }
    &.right {
        .texts {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            @media (--viewport-tablet) {
                flex-direction: column;
                align-items: flex-start;
            }

            &__wrap {
                padding-right: calc(var(--grid-column) * 3);
                padding-left: 0;
                order: 2;

                @media (--viewport-laptop) {
                    padding-right: calc(var(--grid-column-laptop) * 1);
                }

                @media (--viewport-tablet) {
                    width: calc(var(--grid-column-mobile) * 12);
                    padding-left: calc(var(--grid-column-mobile) * 1);
                }
            }

            &__side-illustration {
                padding-left: calc(var(--grid-column) * 2);
                padding-right: var(--grid-column);

                @media (--viewport-laptop) {
                    padding-left: calc(var(--grid-column-laptop) * 3);
                    padding-right: var(--grid-column-laptop);
                }

                @media (--viewport-tablet) {
                    width: calc(var(--grid-column-mobile) * 12);
                    padding-left: calc(var(--grid-column-mobile) * 1);
                    padding-right: 0;
                }

                @media (--viewport-mobile-lp) {
                    width: calc(var(--grid-column-mobile) * 5);
                    margin: 0 auto;
                    padding-left: 0;
                }

                .quote,
                .counter {
                    //padding-left: calc(var(--grid-column) * 2);
                    position: relative;
                    z-index: 1;

                    @media (--viewport-laptop) {
                        padding-left: 0;
                    }

                    @media (--viewport-tablet) {
                        padding-left: 0;
                    }
                }
            }
        }

        &.text-only {
            .texts {
                width: calc(var(--grid-column) * 23);
                padding-left: calc(var(--grid-column) * 9);

                @media (--viewport-laptop) {
                    width: calc(var(--grid-column-laptop) * 25);
                    padding-left: calc(var(--grid-column-laptop) * 11);
                }

                @media (--viewport-tablet) {
                    width: calc(var(--grid-column-mobile) * 11);
                    padding-left: 0;
                }
            }
        }
    }
}

.texts {
    &__text {
        font-size: 0.88rem;
        line-height: 1rem;

        &:not(:last-child) {
            margin-bottom: 0.625rem;

            @media (--viewport-tablet) {
                margin-bottom: 0.8rem;
            }

            @media (--viewport-tablet) {
                margin-bottom: 30px;
            }
        }
    }
}

.blockanimationwrapper {
    height: 200vh;
    margin: 100px 0;
}

.blockanimation {
    position: fixed;
    pointer-events: none;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    display: flex;

    .bg {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: black;
        transform: scaleY(0);
        transform-origin: 0% 100%;
        margin: 0;
    }

    .innersquare {
        display: block;
        width: 50px;
        height: 50px;
        background: white;
        opacity: 0;
    }
}

.svg-container {
    display: inline-block;
    position: relative;
    width: 100%;
    padding-bottom: 100%;
    vertical-align: middle;
    overflow: hidden;
    svg {
        display: inline-block;
        position: absolute;
        top: 0;
        left: 0;
    }
}

.image-fullsize {
    width: 100%;
    padding: 40px 0;
    @media (--viewport-tablet) {
        width: calc(var(--grid-column-mobile) * 11);
        margin-left: var(--grid-column-mobile);
        padding: 0;
    }
    @media (--viewport-mobile-lp) {
        width: calc(var(--grid-column-mobile) * 7);
        margin: 0 auto;
        padding: 10px 0;
    }
}

.animation-block {
    width: 100%;
    padding-top: 60px;
    @media (--viewport-tablet) {
        padding-top: 0px;
    }
}

.gallery-block {
    width: 100%;
}

[data-section-index='1'][data-section='zonehardened'][data-article='brilliant'],
[data-section-index='1'][data-section='zonehardened'][data-article='seka'],
[data-section-index='1'][data-section='zonehardened'][data-article='sever'] {
    .section-heading {
        padding-top: 80px;

        @media (--viewport-tablet) {
            padding-top: 30px;
        }
    }
}

@media (--viewport-tablet) {
    [data-section='zonehardened'] {
        &[data-article='japonchik'] {
            &[data-section-index='2'] {
                [data-section-block-index='0'] {
                    .texts__side-illustration {
                        padding-top: 30px;
                    }
                }
            }
            &[data-section-index='4'] {
                [data-section-block-index='0'] {
                    .texts__side-illustration {
                        padding-top: 30px;
                    }
                }
            }
        }

        &[data-article='svoraf'] {
            &[data-section-index='2'] {
                [data-section-block-index='1'] {
                    .texts__side-illustration {
                        padding-top: 10px;
                        padding-bottom: 30px;
                    }
                }
            }
            &[data-section-index='3'] {
                [data-section-block-index='0'] {
                    .texts__side-illustration {
                        padding-top: 30px;
                    }
                }
            }
            &[data-section-index='4'] {
                [data-section-block-index='1'] {
                    .texts__side-illustration {
                        padding-bottom: 30px;
                    }
                }
            }
        }

        &[data-article='mongol'] {
            &[data-section-index='1'] {
                [data-section-block-index='0'] {
                    .texts {
                        &__wrap {
                            order: 3;
                        }
                        &__side-illustration {
                            order: 0;
                            padding-bottom: 30px;
                        }
                    }
                }
                [data-section-block-index='1'] {
                    .texts {
                        &__side-illustration {
                            padding-bottom: 30px;
                        }
                    }
                }
            }
            &[data-section-index='2'] {
                [data-section-block-index='0'] {
                    .texts {
                        &__side-illustration {
                            padding-top: 30px;
                        }
                    }
                }
            }
            &[data-section-index='3'] {
                [data-section-block-index='2'] {
                    .texts {
                        &__side-illustration {
                            padding-top: 30px;
                        }
                    }
                }
            }
            &[data-section-index='5'] {
                [data-section-block-index='0'] {
                    .texts {
                        &__side-illustration {
                            padding-top: 30px;
                        }
                    }
                }
                [data-section-block-index='1'] {
                    .texts {
                        &__wrap {
                            order: 0;
                        }
                        &__side-illustration {
                            order: 3;
                            padding-top: 30px;
                        }
                    }
                }
            }
        }

        &[data-article='seka'] {
            &[data-section-index='6'] {
                [data-section-block-index='0'] {
                    .texts {
                        &__side-illustration {
                            padding-top: 30px;
                        }
                    }
                }
            }
        }
        &[data-article='sever'] {
            &[data-section-index='3'] {
                [data-section-block-index='2'] {
                    .texts {
                        &__wrap {
                            order: 0;
                        }
                        &__side-illustration {
                            order: 3;
                            padding-top: 30px;
                        }
                    }
                }
            }
            &[data-section-index='4'] {
                [data-section-block-index='0'] {
                    .texts {
                        &__side-illustration {
                            padding-top: 30px;
                        }
                    }
                }
            }
        }
    }
}
</style>
